import { createKkmJournalSink } from '@/features/kkm-journal';
import { setKkmJournalSink } from '@/shared/api';

interface KkmJournalProviderEnvironment {
  document: Document;
  window: Window;
}

let initialized = false;

/** Регистрирует fire-and-forget журнал до первой возможной команды KKMServer. */
export function initializeKkmJournalProvider(environment: KkmJournalProviderEnvironment = { document, window }): void {
  if (initialized) {
    return;
  }

  try {
    const sink = createKkmJournalSink();
    const flushWithBeacon = (): void => sink.flushWithBeacon();
    const flushWhenHidden = (): void => {
      if (environment.document.visibilityState === 'hidden') {
        flushWithBeacon();
      }
    };

    setKkmJournalSink(sink);
    environment.window.addEventListener('pagehide', flushWithBeacon);
    environment.document.addEventListener('visibilitychange', flushWhenHidden);
    initialized = true;
  } catch {
    // Ошибка диагностического контура не блокирует загрузку приложения.
  }
}
